import React from 'react';
export const NotorosLogoDark = '/images/logo/DarkLogo.svg';

export function Logo(props:any)
{
  const width = props.width || "150px";
  return(<img src={NotorosLogoDark} className={"notoros-logo-image"} alt="" width={width}/>);
}